//add a slash at the end if it is not just a slash
export const addSlash = part => (part[part.length - 1] === '/' ? part : `${part}/`);
